import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/api';

export const usePerformance = (timePeriod) => {
  const [performance, setPerformance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPerformance = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      if (timePeriod === 'all') {
        setPerformance(null);
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API_BASE_URL}/snapshots/performance`, {
        params: { days: timePeriod },
        withCredentials: true
      });

      if (response.data.success) {
        setPerformance(response.data);
      }
    } catch (err) {
      console.error('Error fetching performance:', err);
      setError(err.response?.data?.error || 'Failed to load performance data');
    } finally {
      setLoading(false);
    }
  }, [timePeriod]);

  const refresh = useCallback(() => {
    fetchPerformance();
  }, [fetchPerformance]);

  useEffect(() => {
    fetchPerformance();
  }, [fetchPerformance]);

  return { performance, loading, error, refresh };
};
